

































import { Component, Prop, Vue } from "vue-property-decorator"
import { format } from "date-fns"
import { DATE_TIME_FORMAT } from "@/views/grae/ActualitesView.vue"

import TitleView from "@/views/commons/TitleView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import { ActualiteDTO } from "@/model/bean/GeneratedDTOs"

const DEFAULT_ACTUALITE_TAG_COLOR = "#666"
const MAX_NUMBER_OF_CHARACTER = 100

@Component({
  components: { TitleView, ContentView },
})
export default class ActualiteCard extends Vue {
  @Prop() actualite: ActualiteDTO

  isReadMore = false

  mounted(): void {
    this.setIsReadMore()
    this.$nextTick(() => {
      if (this.isReadMore) {
        const readMoreBtn = document.getElementById("read-more-" + this.actualite.id)
        if (readMoreBtn !== null) {
          readMoreBtn.addEventListener("click", (e) => {
            e.stopPropagation()
            this.$emit("read-more", this.actualite.id)
          })
        }
      }
    })
  }

  setIsReadMore(): void {
    this.isReadMore = this.actualite.contenu?.length > MAX_NUMBER_OF_CHARACTER
  }

  getActualiteTypeLabel(): string {
    if (this.actualite.type?.id) {
      return this.actualite.type.label
    } else {
      return this.$t("actualitesPage.actualite-type-undefined").toString()
    }
  }

  getActualiteTypeColor(): string {
    if (this.actualite.type?.id) {
      return this.actualite.type.color
    } else {
      return DEFAULT_ACTUALITE_TAG_COLOR
    }
  }

  getActualiteTruncateContent(): string {
    if (this.actualite.contenu && this.isReadMore) {
      return this.actualite.contenu.slice(0, MAX_NUMBER_OF_CHARACTER) + "..."
    } else {
      return this.actualite.contenu
    }
  }

  formatDate(date: Date): string {
    if (date) {
      return format(date, DATE_TIME_FORMAT)
    }
    return ""
  }
}
